import { Dropdown, MenuButton } from '@mui/joy';
import { CaretDown, CaretUp } from '@phosphor-icons/react';
import { useState } from 'react';

import { IQuotePart } from 'quotes/types';
import { Variant } from 'theme/enums';

import { PricingGuidanceMenu } from './PricingGuidanceMenu';

interface IProps {
  quotePart: IQuotePart;
  onPriceUpdateSuccess: (updatedLine: IQuotePart) => void;
}

export const QuotePartPricingGuidance = ({ quotePart, onPriceUpdateSuccess }: IProps) => {
  const [open, setOpen] = useState(false);

  const isAlternateVersionEnabled = quotePart.alternateVersionEnabled;

  if (!isAlternateVersionEnabled) {
    return null;
  }

  return (
    <Dropdown onOpenChange={(_, open: boolean) => setOpen(open)}>
      <MenuButton variant={Variant.PLAIN} endDecorator={null} sx={menuButtonStyle}>
        {open ? <CaretUp weight="fill" /> : <CaretDown weight="fill" />}
      </MenuButton>

      <PricingGuidanceMenu
        quotePart={quotePart}
        open={open}
        onPriceUpdateSuccess={onPriceUpdateSuccess}
      />
    </Dropdown>
  );
};

const menuButtonStyle = {
  minHeight: 18,
  padding: 0,
  margin: 0,

  '&:hover': {
    backgroundColor: 'transparent',
  },
};
